function getSitePredicate() {
    return document.querySelector("meta[name='site-id']").getAttribute('content');
}

window.showPopupError = function (data) {
    scrollToPopup();
    if (typeof (data) === 'undefined' || data.length === 0) {
        data = 'товара нет в наличии или недостаточное количество';
    }
    $('#error-popup').removeClass('_hidden').find('.js-popup-body').html(data);
}


window.scrollToPopup = function () {
    if (window.vkScrollToPopup) {
        window.vkScrollToPopup();
    }
}

window.FridayApi = {
    create: function (dataType, data, callback) {
        data.token = $('body').data('token');
        data.action = 'create';
        $.ajax({
            url: getSitePredicate() + '/api/' + dataType + '/',
            data: data,
            dataType: 'json',
            method: 'post',
            success: function (data) {
                callback(data);
            },
            error: function (data) {
                callback(data);
            }
        })
    },
    show: function (dataType, data, callback) {
        data.action = 'index';
        $.ajax({
            url: getSitePredicate() + '/api/' + dataType + '/' + data.id + '/',
            dataType: 'json',
            method: 'get',
            success: function (data) {
                callback(data);
            },
            error: function (data) {
                callback(data);
            }
        })
    },
    index: function (dataType, data, callback) {
        data.action = 'index';
        $.ajax({
            url: getSitePredicate() + '/api/' + dataType + '/',
            data: data,
            dataType: 'json',
            method: 'get',
            success: function (data) {
                callback(data);
            },
            error: function (data) {
                callback(data);
            }
        })
    },
    update: function (dataType, data, callback) {
        data.token = $('body').data('token');
        data.action = 'update';
        $.ajax({
            url: getSitePredicate() + '/api/' + dataType + '/' + data.id + '/',
            data: data,
            dataType: 'json',
            method: 'post',
            success: function (data) {
                callback(data);
            },
            error: function (data) {
                callback(data);
            }
        })
    },
    delete: function () {

    }
};
$(function () {
    let $scroller = $('.js-slide-up'),
        didScroll = false,
        $body = $('body'),
        $burger = $('.js-show-tablet-menu'),
        $popupOverlay = $('.js-tablet-menu-overlay'),
        itemCount = 1,
        article = $('.js-article').html(),
        $product = $('.js-product-data'),
        $expandMenu = $('.js-expand-menu'),
        $expandMenuArrow = $('.js-menu-arrow-toggle'),
        menuAnimation = 0,
        $myCartCount = $('.js-my-cart-count');

    $('.js-slider-wrap').slick({
        prevArrow: $(this).find('.js-left-arrow'),
        nextArrow: $(this).find('.js-right-arrow'),
        autoplay: true,
        autoplaySpeed: 4000
    });

    function hideSubmenu() {
        $(this).find('.js-submenu').addClass('_hidden');
    }

    function showSubmenu() {
        $(this).find('.js-submenu').removeClass('_hidden');
    }

    function hideMobileSubmenu() {
        $(this).find('.js-arrow-toggle').removeClass('_expanded');
        $(this).parents('.js-menu-item').find('.js-submenu').addClass('_hidden');
    }

    function showMobileSubmenu() {
        $(this).find('.js-arrow-toggle').addClass('_expanded');
        $(this).parents('.js-menu-item').find('.js-submenu').removeClass('_hidden');
    }


    function canAddItemToCard() {
        let quantity = +$('.js-select-offer._active').data('available');
        return quantity > itemCount;
    }

    function formatMoney(sum) {
        sum = '' + sum;
        sum = sum.split('');
        for (i = sum.length - 1, j = 1; i >= 0; i--, j++) {
            if (j > 0 && j < sum.length && j % 3 === 0) {
                sum[i] = ' ' + sum[i];
            }
        }
        sum = sum.join('');
        return sum;
    }

    $expandMenuArrow.click(function () {
        if ($(this).hasClass('_expanded')) {
            hideMobileSubmenu.bind(this)();
            $(this).removeClass('_expanded');
        } else {
            showMobileSubmenu.bind(this)();
            $(this).addClass('_expanded');
        }
    });

    $expandMenu.mouseover(function () {
        showSubmenu.bind(this)();
    });

    $expandMenu.mouseout(function () {
        hideSubmenu.bind(this)();
    });

    $('.js-personal-show-password').click(function () {
        $(this).addClass('_hidden');
        $('.js-personal-password').removeClass('_hidden');
    });

    $('.js-product-slider').slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear'
    });

    $('.js-count-plus').click(function () {
        if (canAddItemToCard()) {
            itemCount++;
            setCount();
        } else {
            showPopupError('Невозможно выбрать больше товара');
        }
    });

    $('.js-count-minus').click(function () {
        if (itemCount > 1) {
            itemCount--;
            setCount();
        }
    });

    $('.js-cart-quantity').click(function () {
        $($(this).data('target')).html($($(this).data('quantity')).val());

        let quantitys, i, prices, summPrice = 0;
        quantitys = document.querySelectorAll('.js-cart-quantity-value');
        prices = document.querySelectorAll('.js-cart-price');
        for (i = 0; i < quantitys.length; i++) {
            summPrice += parseInt(quantitys[i].innerHTML) * parseInt(prices[i].innerHTML);
        }
        document.querySelector('.js-cart-summary').innerHTML = formatMoney(summPrice) + ' руб';
    });

    let $selectContainerLine = $('.js-select'),
        $selectContainerOptionWrap = $('.js-select-wrap'),
        $selectContainerOptionBlock = $('.js-select-option-block'),
        $selectContainerOptionItem = $('.js-select-option-item'),
        $selectContainerText = $('.js-select-text');

    $('.js-select-size').click(function () {
        article = $(this).data('sku');
        $('.js-select-size').removeClass('_active');
        $(this).addClass('_active');
        setArticle();
        resetBasketButton();
    });

    $body.on('click', '.js-select-offer, .js-popup-select-size', function () {
        // чел кликает по предложению в карточке товара - надо изменить цену (у предложения она может быть другая)
        const offerPrice = $(this).data('offer-price');
        if (offerPrice) {
            const detailPagePriceContainer = $('.product-detail__price div');
            const priceContainer = detailPagePriceContainer.length > 0 ? detailPagePriceContainer : $('.popup-product-detail__price');

            priceContainer[0].innerHTML = offerPrice;
        }
    });

    $selectContainerLine.click(function () {
        $selectContainerOptionBlock.toggleClass('_hidden');
        $selectContainerLine.toggleClass('_opened');
    });

    $selectContainerOptionItem.click(function () {
        article = $(this).data('sku');
        setArticle();
        $selectContainerOptionItem.removeClass('_active');
        $(this).addClass('_active');
        $selectContainerOptionBlock.addClass('_hidden');
        $selectContainerLine.removeClass('_opened');
        $selectContainerText.html($(this).html());
    });

    $('.js-select-model').click(function () {
        article = $(this).data('sku');
        setArticle();
    });
    $('.js-search-line-toggle').click(function () {
        $('.js-search-line-changing-element').toggleClass('desktop');
        $('.js-search-line-close').toggleClass('_hidden');
        $('.js-search-line').focus();
    });

    $body.on('click', '.js-make-order', function (e) {
        e.preventDefault();
        let productID = $product.data('id');
        let offerID = $('.js-select-offer._active').data('id');
        let id = 0;
        if (!selectedModel()) {
            showPopupError('Необходимо выбрать модель телефона');

            return false;
        }
        if (offerID && parseInt(offerID) !== 0) {
            id = offerID;
        } else {
            id = productID;
        }
        if (parseInt(id) > 0) {
            FridayApi.create(
                'myCart',
                {
                    article: article,
                    count: itemCount,
                    id: id
                },
                function (data) {
                    if (data.status === 'ok') {
                        FridayApi.index(
                            'myCart',
                            {},
                            function (dataReturned) {
                                $myCartCount.html(dataReturned.data.TOTAL_QUANTITY);
                                if (dataReturned.data.TOTAL_QUANTITY > 0) {
                                    $myCartCount.addClass('_active');
                                    let $btnOrder = $('.js-make-order');
                                    $btnOrder.html('перейти в корзину').removeClass('js-make-order').addClass('js-go-card');
                                } else {
                                    $myCartCount.removeClass('_active');
                                }

                            }
                        )

                    } else if (data.status === 'error') {
                        console.log(data);
                        showPopupError(data.code);
                    }
                });
        }
    });

    function selectedModel() {
        return !($selectContainerOptionWrap.length > 0 && $selectContainerOptionWrap.find('.js-select-offer._active').length === 0);
    }


    function setCount() {
        $('.js-count').html(itemCount);
    }

    function setArticle() {
        $('.js-article').html(article);
    }

    function resetBasketButton() {
        $('.js-go-card').html('добавить в корзину').removeClass('js-go-card').addClass('js-make-order')
    }

    $('[data-scrollto-block]').click(function () {
        $('html, body').scrollTop($($(this).data('scrollto-block')).offset().top - 60);
    });

    $('[data-show-block]').click(function () {
        $($(this).data('show-block')).removeClass('_hidden').addClass('_shown');
    });

    $('[data-hide-block]').click(function () {
        $($(this).data('hide-block')).removeClass('_shown').addClass('_hidden');
    });

    // show product sliders
    window.imageGaleryBlock($('.js-product-gallery-wrap')).show();

    $('.js-popup-close').click(function () {
        hidePopup($($(this).data('target')));
    });

    function hidePopup(popup) {
        popup.addClass('_hidden');
    }

    function checkScroller() {
        if ($(window).scrollTop() > 0 && !($scroller.hasClass('_showed'))) {
            $scroller.addClass('_showed');
        }
        if ($(window).scrollTop() === 0) {
            $scroller.removeClass('_showed');
        }
    }

    setInterval(function () {
        if (didScroll) {
            didScroll = false;
            checkScroller();
        }
    }, 300);

    function scrollStuff() {
        didScroll = true;
    }

    $(window).on('touchmove', function () {
        scrollStuff();
    });

    $(window).scroll(function () {
        scrollStuff();
    });

    $scroller.click(function () {
        $(window).scrollTop(0, 0);
        $(this).removeClass('_showed');
    });

    $popupOverlay.click((e) => {
        $burger.click();
    });

    $burger.click(function () {
        $(this).parent().toggleClass('_close');
        $('body').toggleClass('_no-overflow');
        $popupOverlay.toggleClass('_active');
        $('.js-tablet-menu').toggleClass('_active');
        console.log(window.vkResizeOnMenuShown);
        if (window.vkResizeOnMenuShown && typeof window.vkResizeOnMenuShown === 'function') {
            window.vkResizeOnMenuShown();
        }
    });

    $body.on('keyup', '[data-validation="tel"]', function () {
        console.log('sss0');
        console.log($(this))
        console.log($(this).val())
        console.log($(this).html())
        $(this).val($(this).val().replace(/[^0-9+]/g, ''));
    });
    /*$burger.bigSlide({menu:'.js-tablet-menu-body'});*/
    //order page fixes
});



//////////////////
// WEBPACK FOOTER
// ./src/js/scripts.js
// module id = 5
// module chunks = 0 1 2